const parseBold = (input: string) => {
  return input.replace(/\*(.*?)\*/g, '<b>$1</b>')
}

// remvove * if it occurs between a word
const removeAsterisk = (input: string) => {
  return input.replace(/\*/g, '')
}

export {parseBold, removeAsterisk}
